import axios from 'axios'
import { URL } from '../../../../config'

export const postStandardGames = function (updates,token) 
{
  const standardgamesEndpoint = `/standardgames/update`
  const  standardgamesURL =  `${URL.postevent}${standardgamesEndpoint}` 
  return axios.post(standardgamesURL,updates,
	{ 
    crossdomain: true,
    headers: {
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      'Authorization' : `Bearer ${token}` 
    }
  })
}


// WEBPACK FOOTER //
// ./src/components/pages/Event/api/postStandardGames.js